import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { themesKey } from '@dashboard/lib/queryKeys';
import { getThemes } from './queries/useThemeQueries';

/**
 * Resolves page.theme from a string ID to a full theme object using the
 * cached themes list. Prevents FOUC when navigating to PageEdit before the
 * single-page API has returned the populated theme.
 */
export default function useResolvedPageTheme(page) {
  const { token, sellerId } = useAuth();

  const { data: themes } = useQuery({
    queryKey: themesKey(sellerId),
    queryFn: () => getThemes(token, sellerId),
    enabled: !!token && !!sellerId,
  });

  if (!page || !themes) return page;

  const themeId = typeof page.theme === 'string' ? page.theme : page.theme?._id;

  if (!themeId) return page;

  const resolved = themes.find(t => t._id === themeId);

  if (!resolved) return page;

  return { ...page, theme: resolved };
}
